// Import style lib
import { createGlobalStyle } from 'styled-components';

// Import style files
import Fonts from './Fonts';
import colors from './colors';

const StyledGlobalStyle = createGlobalStyle`
    ${Fonts}

    *, *::before, *::after{        
        // Global reset
        margin: 0;
        padding: 0;
        box-sizing: border-box;

        //outline: 1px solid red;
    }

    html, body, #root {
        width: 100%;
        height: 100%;
    }

    body {
        background-color: #fff;

        font-family: 'Nunito', sans-serif;
        color: ${colors.textBlack};
        line-height: 1.5;

        -webkit-font-smoothing: antialiased;
    }

    #root {
        display: flex;
        flex-direction: column;
    }

    h1, h2, h3 {
        font-weight: bold;
        
        margin: 0;
        padding: 0;
    }

    h1 {
        font-size: 1.5rem;

        /* Mobile setup */
        @media (max-width: 600px) {
            font-size: 1.3rem;
        }
    }

    h2 {
        font-size: 1.2rem;

        /* Mobile setup */
        @media (max-width: 600px) {
            font-size: 1rem;
        }
    }

    h3 {
        font-size: 1rem;

        /* Mobile setup */
        @media (max-width: 600px) {
            font-size: 0.8rem;
        }
    }

    img, svg {
        display: block;

        max-width: 100%;
        height: auto;
    }

    button, input, textarea {
        font: inherit;

        border: none;
        outline: none;

        background: none;
    }

    a {
        text-decoration: none;
        color: inherit;
    }

    p, a, button, input, textarea, label {
        font-size: 1rem;

        /* Mobile setup */
        @media (max-width: 600px) {
            font-size: 0.8rem;
        }
    }
`;

function GlobalStyle() {
    return <StyledGlobalStyle />;
}

export default GlobalStyle;
